import * as React from 'react';
import { clsx } from 'clsx';
import { isBefore, isAfter, lastDayOfMonth, startOfMonth, sub, add, isSameYear } from 'date-fns';
import { UIHeading3 } from '../../../../../typography';
import { IconActionChevronDown16, IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { ECalendarPickerPage } from '../types';
import * as styles from './styles.module.css';
import { format } from '../../../../../internal/utils/date';
import { IconButton } from '../../IconButton';
import { generateDataTestId } from '../../../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CalendarPickerHeader(_ref) {
  var current = _ref.current,
    min = _ref.min,
    max = _ref.max,
    page = _ref.page,
    onChangeYearClick = _ref.onChangeYearClick,
    onPrevMonthClick = _ref.onPrevMonthClick,
    onNextMonthClick = _ref.onNextMonthClick,
    dataTestId = _ref.dataTestId;
  var isSingleYear = !!(min && max && isSameYear(min, max));
  var isMinDisabled = !!(min && isBefore(lastDayOfMonth(sub(current, {
    months: 1
  })), min));
  var isMaxDisabled = !!(max && isAfter(startOfMonth(add(current, {
    months: 1
  })), max));
  var handleClickTitle = function handleClickTitle() {
    onChangeYearClick();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles['header'],
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles['title'], !isSingleYear && styles['clickable']),
      onClick: isSingleYear ? undefined : handleClickTitle,
      "data-test": page === ECalendarPickerPage.Year ? 'toCalendarView' : 'toYearsView',
      children: [/*#__PURE__*/_jsx(UIHeading3, {
        userSelect: "none",
        "aria-live": "polite",
        children: format('LLLL y', current)
      }), !isSingleYear && /*#__PURE__*/_jsx(IconButton, {
        className: clsx(styles['icon-button'], page === ECalendarPickerPage.Year && styles['year-active']),
        "aria-label": page === ECalendarPickerPage.Year ? 'Открыт выбор года, переключить на календарь' : 'Открыт календарь, переключить на выбор года',
        children: /*#__PURE__*/_jsx(IconActionChevronDown16, {
          color: "icon-main-default"
        })
      })]
    }), page === ECalendarPickerPage.Month && /*#__PURE__*/_jsxs("div", {
      className: styles['buttons'],
      children: [/*#__PURE__*/_jsx(IconButton, {
        className: styles['icon-button'],
        onClick: onPrevMonthClick,
        disabled: isMinDisabled,
        "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
        "data-testid": generateDataTestId(dataTestId, ['previous']),
        children: /*#__PURE__*/_jsx(IconActionChevronLeft16, {
          color: isMinDisabled ? 'icon-main-disabled' : 'icon-main-default'
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        className: styles['icon-button'],
        onClick: onNextMonthClick,
        disabled: isMaxDisabled,
        "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
        "data-testid": generateDataTestId(dataTestId, ['next']),
        children: /*#__PURE__*/_jsx(IconActionChevronRight16, {
          color: isMaxDisabled ? 'icon-main-disabled' : 'icon-main-default'
        })
      })]
    })]
  });
}